<div class="flex">
  <div class="flex-grow">
    <h3 *ngIf="title" nz-typography class="flex-grow">
      {{ title }}
      <span *ngIf="subtitle" page-secondary nz-typography nzType="secondary">{{ subtitle }}</span>
    </h3>
    <div *ngIf="description" page-description class="text-md">{{ description }}</div>
  </div>
  <ng-container *ngIf="extraTemplate">
    <ng-container *ngTemplateOutlet="extraTemplate; context: { $implicit: user }"></ng-container>
  </ng-container>
  <div class="flex items-center space-x-2">
    <ng-container *ngIf="buttonTemplate">
      <ng-container *ngTemplateOutlet="buttonTemplate; context: { $implicit: user }"></ng-container>
    </ng-container>
   
    <button
      *ngIf="button && button.privilege && hasPrivilege(button.privilege)"
      [routerLink]="button.link"
      (click)="handleButtonClick()"
      nz-button
      nzType="primary"
    >
      {{ button.label }}
    </button>
     <button
      *ngIf="button2 && (!button2.privilege || hasPrivilege(button2.privilege))"
      [routerLink]="button2.link"
      (click)="handleButton2Click()"
      nz-button
      nzType='default'
    >
      {{ button2.label }}
    </button>
  </div>
</div>
